import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ReferencesPerEntryPointBarChart = ({ data, isLoading }) => {
  const blueShades = [
    "rgba(54, 162, 235, 0.6)",
    "rgba(75, 192, 192, 0.6)",
    "rgba(99, 132, 255, 0.6)",
    "rgba(153, 102, 255, 0.6)",
    "rgba(201, 203, 207, 0.6)",
  ];

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Number of References",
        data: [],
        backgroundColor: [],
      },
    ],
  });

  useEffect(() => {
    if (isLoading || !data || data.length === 0) {
      return;
    }

    const processData = () => {
      const entryPointCounts = {};
      data.forEach((item) => {
        const entryPoint = item.header.pedimento.pedimento_entry_point;
        entryPointCounts[entryPoint] = (entryPointCounts[entryPoint] || 0) + 1;
      });

      const sortedEntryPoints = Object.entries(entryPointCounts)
        .sort((a, b) => b[1] - a[1])
        .reduce(
          (acc, curr) => {
            acc.keys.push(curr[0]);
            acc.values.push(curr[1]);
            return acc;
          },
          { keys: [], values: [] }
        );

      setChartData({
        labels: sortedEntryPoints.keys,
        datasets: [
          {
            label: "Number of References",
            data: sortedEntryPoints.values,
            backgroundColor: sortedEntryPoints.keys.map(
              (_, index) => blueShades[index % blueShades.length]
            ),
          },
        ],
      });
    };

    processData();
  }, [data, isLoading]);

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
      datalabels: {
        anchor: "end",
        align: "end",
        offset: 10,
        backgroundColor: "rgba(135, 206, 250, 0.8)",
        borderColor: "rgba(0, 0, 0, 0.1)",
        borderRadius: 4,
        borderWidth: 1,
        color: "#000",
        font: {
          weight: "bold",
        },
        formatter: (value) => value,
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          References per Entry Point Chart
        </h2>
      </div>
      <div className="flex-grow relative">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <FontAwesomeIcon
              icon={faSpinner}
              className="animate-spin text-xl"
            />
            <span className="ml-2 text-lg">Loading...</span>
          </div>
        ) : (
          <Bar data={chartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default ReferencesPerEntryPointBarChart;
